module.exports = __webpack_public_path__ + "img/20190810114542016.c7a22ba2.png";